import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { AuthRoleGuard } from './auth-role.guard';
import { LoggedGuard } from './logged.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'menu/categorias',
    loadChildren: () => import('./menu/categorias/categorias.module').then( m => m.CategoriasPageModule)
  },
  {
    path: 'locales',
    loadChildren: () => import('./locales/locales.module').then( m => m.LocalesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule),
    canActivate: [LoggedGuard]
  },
  {
    path: 'local/:local',
    loadChildren: () => import('./local/local.module').then( m => m.LocalPageModule)
  },
  {
    path: 'auth/list',
    loadChildren: () => import('./auth/list/list.module').then( m => m.ListPageModule),
    data: {
      role: ['admin']
    },
    canActivate: [AuthGuard, AuthRoleGuard]
  },
  {
    path: 'menu/productos',
    loadChildren: () => import('./menu/productos/productos.module').then( m => m.ProductosPageModule)
  },
  {
    path: 'empleados',
    loadChildren: () => import('./mobile-login/mobile-login.module').then( m => m.MobileLoginPageModule)
  },
  {
    path: 'employee',
    loadChildren: () => import('./employee/employee.module').then( m => m.EmployeePageModule)
  },
  {
    path: 'registro',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then( m => m.InvoicesPageModule)
  },
  {
    path: 'manuales',
    loadChildren: () => import('./manuales/manuales.module').then( m => m.ManualesPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
